import { createFragmentContainer, graphql } from 'react-relay';
import EventCreateComponent from './';

export default createFragmentContainer(EventCreateComponent, {
  viewer: graphql`
    fragment EventCreateContainer_viewer on User {
      id
      past_referral_sources
      s_time_zone
      ...AvailabilityCheckerContainer_viewer
      ...AvailabilityCalendarContainer_viewer
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Event/Create/EventCreateContainer.js